var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-text-area",class:{ 
    block: _vm.block
  }},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('textarea',{class:{ 
      block: _vm.block
    },attrs:{"rows":_vm.rows,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.modelValue},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }